import { render, staticRenderFns } from "./QuestionMatrixRate.vue?vue&type=template&id=c00f3b40&scoped=true&"
import script from "./QuestionMatrixRate.vue?vue&type=script&lang=js&"
export * from "./QuestionMatrixRate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMatrixRate.vue?vue&type=style&index=0&id=c00f3b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00f3b40",
  null
  
)

export default component.exports